<template>
  <div class="liveParent">
    <el-breadcrumb class="bread-nav" separator="/">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>KV直播</el-breadcrumb-item>
      <el-breadcrumb-item>查询直播</el-breadcrumb-item>
    </el-breadcrumb>
    <el-table :data="liveListData" border stripe style="width: 100%">
      <el-table-column type="expand">
        <template scope="props">
            <el-form label-position="left" inline class="live-table-expand">
            <el-form-item label="KV直播ID">
                <span>{{ props.row.id }}</span>
            </el-form-item>
            <el-form-item label="投放公司">
                <span>{{ props.row.fromCompany }}</span>
            </el-form-item>
            <el-form-item label="标题">
                <span>{{ props.row.liveTitle }}</span>
            </el-form-item>
            <el-form-item label="创建者">
                <span>{{ props.row.userName }}</span>
            </el-form-item>
            <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
            </el-form-item>
            <el-form-item label="更新时间">
                <span>{{ props.row.updateTime }}</span>
            </el-form-item>
            <el-form-item id="liveUrl" label="直播源连接">
                <span>{{ props.row.liveUrl }}</span>
            </el-form-item>
            <el-form-item id="sourceUrl" label="直播服务连接">
                <span>{{sourcePath+props.row.id }}</span>
            </el-form-item>
            </el-form>
        </template>
      </el-table-column>
      <el-table-column label="KV直播ID" width="120" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.liveTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column label="投放公司" width="150" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.fromCompany }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建者" width="180" header-align="center" align="center">
        <template scope="scope">
          <span style="margin-left: 10px">{{ scope.row.userName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center" width="300">
        <template scope="scope">
          <el-button size="small" @click="toLive(scope.$index, scope.row)">查看</el-button>
          <el-button size="small" :type="scope.row.liveOffline|isLiveOfflineColor" @click="contralLiveLine(scope.$index, scope.row)">
            {{scope.row.liveOffline|isLiveOffline}}
          </el-button>
          <el-button size="small" :type="scope.row.isOpenComment|isOpenCommentFilterColor" @click="contralComment(scope.$index, scope.row)">
            {{scope.row.isOpenComment|isOpenCommentFilter}}
          </el-button>
          <el-button size="small" @click="contralEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-size="10"
      layout="total,prev,pager,next,jumper"
      :total="total">
    </el-pagination>
    <el-dialog v-model="editDialog" :title="editTitle" size="small" top="13%" custom-class="editDialog" :modal-append-to-body="false" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="editRules" label-width="80px">
        <el-form-item label="直播标题" prop="liveTitle">
          <el-input v-model="form.liveTitle"></el-input>
        </el-form-item>
        <el-form-item label="投放公司" prop="fromCompany">
          <el-input v-model="form.fromCompany"></el-input>
        </el-form-item>
        <el-form-item label="" prop="isLiveBgImg">
          <el-checkbox v-model="form.isLiveBgImg" @change="changeIsLiveBgImg()">设置背景图</el-checkbox>
        </el-form-item>
        <el-form-item ref="liveBgImg" label="" prop="liveBgImg">
          <el-input v-model="form.liveBgImg" :disabled="!form.isLiveBgImg" placeholder="背景图链接（尺寸940px*1136px）"></el-input>
        </el-form-item>
        <el-form-item label="直播源">
          <el-select @change="changeLiveSource()" v-model="form.liveSource" placeholder="请选择直播源">
            <el-option v-for="item in form.liveSourceList" :key="item.name" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缩略图" prop="otherImg">
          <el-input v-model="form.otherImg" :disabled="!form.liveSource.otherImg" placeholder="背景图链接（尺寸940px*1136px）"></el-input>
        </el-form-item>
        <el-form-item label="直播链接" prop="liveUrl">
          <el-input v-model="form.liveUrl"></el-input>
        </el-form-item>
        <el-form-item label="直播描述" prop="liveContent">
          <el-input type="textarea" :rows="2" placeholder="请输入直播描述" v-model="form.liveContent"></el-input>
        </el-form-item>
        <el-form-item label="" prop="isShare">
          <el-checkbox v-model="form.isShare" @change="changeShare()">开启分享</el-checkbox>
        </el-form-item>
        <el-form-item label="分享链接" prop="shareUrl">
          <el-input v-model="form.shareUrl" :disabled="!form.isShare" placeholder="请输入分享链接（选填）"></el-input>
        </el-form-item>
        <el-form-item label="分享头图" prop="shareImg">
          <el-input v-model="form.shareImg" :disabled="!form.isShare" placeholder="请输入分享头图，尺寸200x200（必填）"></el-input>
        </el-form-item>
        <el-form-item label="分享标题" prop="shareTitle">
          <el-input v-model="form.shareTitle" :disabled="!form.isShare" placeholder="请输入分享标题（必填）"></el-input>
        </el-form-item>
        <el-form-item label="分享描述" prop="shareDesc">
          <el-input v-model="form.shareDesc" :disabled="!form.isShare" placeholder="请输入分享描述（必填）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editBtn()">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import CONFIG from "@/config/index.js";
  import TOOL from '@/tool/index.js';
  import router from "@/router/index.js";
  import { mapGetters } from 'vuex';
  import co from 'co';
  export default {
    name: "kvliveList",
    data() {
      return {
        editDialog:false,
        liveListData:null,
        total:0,
        sourcePath:CONFIG.HOST+'/view/live/',
        editTitle:"编辑kv直播",
        form:{
          liveSource:{}
        },
        editRules:{
          liveTitle: [
            { required: true, message: '请输入直播标题'},
          ],
          fromCompany: [
            { required: true, message: '请输入投放公司'},
          ],
          liveSource: [
            { required: true, message: '请选择直播源'},
          ],
          liveUrl: [
            { validator: this._checkLiveUrl, trigger: 'blur' }
          ],
          liveBgImg: [
            { validator: this._checkLiveBgImg, trigger: 'blur' }
          ],
          otherImg: [
            { validator: this._checkOtherImg, trigger: 'blur' }
          ],
          shareTitle: [
            { validator: this._checkShareTitle, trigger: 'blur' }
          ],
          shareDesc: [
            { validator: this._checkShareContent, trigger: 'blur' }
          ],
          shareImg: [
            { validator: this._checkShareImg, trigger: 'blur' }
          ],
        }
      }
    },
    filters: {
        isLiveOffline: function (value) {
            let tmpval = Number(value);
            if (tmpval===0)
             return '下线';
            else
             return '上线';
        },
        isLiveOfflineColor: function (value) {
            let tmpval = Number(value);
            if (tmpval===0)
             return 'danger';
            else
             return 'primary';
        },
        isOpenCommentFilter: function (value) {
            let tmpval = Number(value);
            if (tmpval===0)
             return '开启评论';
            else
             return '关闭评论';
        },
        isOpenCommentFilterColor: function (value) {
            let tmpval = Number(value);
            if (tmpval===0)
             return 'success';
            else
             return 'warning';
        },
    },
    methods: {
      //分页查询
      handleCurrentChange(val){
        this.currentPage = val;
        this.$http.get(CONFIG.HOST + "/live/liveListPaging/"+val).then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.liveListData = result.data.liveListPaging;
            this.total = result.data.totalCounts[0].counts;
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
      },
      //查看直播
      toLive(index,row){
        window.open(this.sourcePath+row.id);
      },
      //点击提交按钮
      editBtn(){
        let flag = true;
        // console.log(this.$refs['form'].validate)
        this.$refs['form'].validate((valid) => {
          if (!valid) {
            flag = false;
            return false;
          }
        });
        if(!flag){
          return;
        }else{
          this.editBtnService();
        }
      },
      editBtnService(){
        var self = this;
        var form = this.form;
        var formData = Object.create(null);
        formData.liveTitle = form.liveTitle.trim();
        formData.liveBgImg = (!!form.liveBgImg&&!!form.liveBgImg.trim())?form.liveBgImg.trim():null;
        formData.liveUrl = form.liveUrl.trim();
        formData.liveContent = form.liveContent;
        formData.fromCompany = form.fromCompany.trim();
        formData.isOpenComment = form.isOpenComment;
        formData.shareTitle = form.shareTitle;
        formData.shareDesc = form.shareDesc;
        formData.shareImg = form.shareImg;
        formData.shareUrl = form.shareUrl;
        formData.isShare = Boolean(form.isShare);
        formData.otherImg = form.otherImg;
        this.editBtnServiceCo(formData)()
        .catch(()=>{
            self.$notify.error({
              message: "修改失败"
            });
        });
      },
      editBtnServiceCo(formData){
        var self = this;
        function* gen(){
          var result = yield self.$http.put(CONFIG.HOST + '/live/updateLive/'+self.form.id,formData);
          if(result.body.status===1){
            self.editDialog=false;
            self._init();
            self.$notify.success({
              message: "修改成功"
            });
          }else{
            // console.log(result)
            self.$notify.error({
              message: result.body.message
            });
          }
        }
        return co.wrap(gen);
      },
      //校验背景图
      _checkLiveBgImg(rule, value, callback){
        if(!this.form.isLiveBgImg){
          callback();
        }else{
          let reg = /^https?\:\/\/.*yidianzixun\.com/;
          if(reg.test(value)){
            callback();
          }else{
            callback(new Error('请输入以包含yidianzixun.com域名的图片链接'));
          }
        }
      },
      //校验缩略图
      _checkOtherImg(rule, value, callback){
        if(!this.form.liveSource.otherImg){
          callback();
        }else{
          let reg = /^https?\:\/\/.*yidianzixun\.com/;
          if(reg.test(value)){
            callback();
          }else{
            callback(new Error('请输入以包含yidianzixun.com域名的图片链接'));
          }
        }
      },
      //校验直播源
      _checkLiveUrl(rule, value, callback){
        if(this.form.liveSource.reg.test(value)){
          callback();
        }else{
          callback(new Error('请输入'+this.form.liveSource.name+"平台的直播源链接"));
        }
      },
      //校验分享标题
      _checkShareTitle(rule, value, callback){
        if(!this.form.isShare){
          callback();
        }else{
          if(!value||!value.trim()){
            callback(new Error('请输入的分享标题'));
          }else{
            callback();
          }
        }
      },
      //校验分享描述
      _checkShareContent(rule, value, callback){
        if(!this.form.isShare){
          callback();
        }else{
          if(!value||!value.trim()){
            callback(new Error('请输入的分享描述'));
          }else{
            callback();
          }
        }
      },
      //校验分享头图
      _checkShareImg(rule, value, callback){
        if(!this.form.isShare){
          callback();
        }else{
          let reg = /^https?\:\/\/.*yidianzixun\.com/;
          if(reg.test(value)){
            callback();
          }else{
            callback(new Error('请输入以包含yidianzixun.com域名的图片链接'));
          }
        }
      },
      //设置背景图触发校验
      changeIsLiveBgImg(){
        this.$refs['form'].validateField('liveBgImg',(errmessage)=>{
          console.log(errmessage);
        });
      },
      //开启、关闭分享时触发分享校验
      changeShare(){
        this.$refs['form'].validateField('shareTitle',(errmessage)=>{
          console.log(errmessage);
        });
        this.$refs['form'].validateField('shareDesc',(errmessage)=>{
          console.log(errmessage);
        });
        this.$refs['form'].validateField('shareImg',(errmessage)=>{
          console.log(errmessage);
        });
      },
      //直播源改变触发校验
      changeLiveSource(){
        this.$refs['form'].validateField('otherImg',(errmessage)=>{
          console.log(errmessage);
        });
        this.$refs['form'].validateField('liveUrl',(errmessage)=>{
          console.log(errmessage);
        });
      },
      //深克隆方法
      deepCopy(val){
        let self = this;
        let loopArr = [];
        function deepCopyService(value){
          if(value===null||typeof value!=="object"){
            return value;
          }
          loopArr.push(value);
          let tmpValue = Object.prototype.toString.call(value)==="[object Array]"?[]:{};
          let keys = Object.keys(value);
          for(let i of keys){ 
            let v = value[i]; 
            if (loopArr.indexOf(v) > -1) { 
                throw Error("深克隆失败");      
            } 
            tmpValue[i] = deepCopyService(v);
          }
          return tmpValue;
        }
        return deepCopyService(val);
      },
      //一层克隆组件组件数据方法,参数1data属性，参数2赋值对象
      deepVueData(str,obj){
        let self = this;
        let keys = Object.keys(obj);
        for(let i of keys){ 
            let v = obj[i]; 
            self.$set(self[str],i,v);
          }
      },
      //工具函数，过滤
      filters(arr,str){
        if(!arr||Object.prototype.toString.call(arr)!=="[object Array]"){
          return undefined;
        }
        return arr.find((value,index,arr)=>{
          return value.reg.test(str);
        });
      },
      //打开编辑对话框
      contralEdit(index,row){
        this.editTitle = "编辑kv直播-"+row.liveTitle;
        var tmpValue = this.deepCopy(row);
        tmpValue["isLiveBgImg"] = Boolean(row.liveBgImg);
        tmpValue['liveSourceList'] = [
          {name:'斗鱼',otherImg:false,reg:/^https?\:\/\/\w{1,3}\.douyu\.com\//},
          {name:'芒果',otherImg:false,reg:/^https?\:\/\/.*\.mgtv\.com\//},
          {name:'微吼',otherImg:false,reg:/^https?\:\/\/www\.vhall\.com\//},
          {name:'映客',otherImg:true,reg:/^https?\:\/\/.*inke\./},
          {name:'花椒',otherImg:true,reg:/^https?\:\/\/h\.huajiao\.com\//},
          {name:'爱奇艺',otherImg:false,reg:/^https?\:\/\/.*iqiyi\.com/},
          {name:'天眼直播',otherImg:false,reg:/^https?\:\/\/video\.sina\.com\.cn/},
          {name:'优酷',otherImg:false,reg:/^https?\:\/\/vku\.youku\.com\//},
          {name:'一点资讯',otherImg:true,reg:/(?:^https?\:\/\/livepull\.go2yd\.com\/)|(?:^https?\:\/\/.+.mp4$)/},
          {name:'一直播',otherImg:true,reg:/^https?\:\/\/.*yizhibo\.com\//},
        ];
        tmpValue['liveSource'] = this.filters(tmpValue['liveSourceList'],tmpValue.liveUrl);
        if(!tmpValue['liveSource']){
          return this.$notify.error({
              message: "该直播数据错误，无法进行编辑"
            });
        }
        tmpValue['isShare'] = Boolean(tmpValue['isShare']);
        this.deepVueData('form',tmpValue);
        this.editDialog = true;
        if(this.$refs['form']){
          this.$refs['form'].validate(()=>{});
        }else{
          setTimeout(()=>{
            this.$refs['form'].validate(()=>{});
          },0);
        }
      },
      //上线下线
      contralLiveLine(index,row){
        let self = this;
        let liveObj = {
          pathUrl:null,
          message:null
        };
        //判断上线还是下线
        row.liveOffline===0?(liveObj.pathUrl="/live/liveOffline/",liveObj.message="下线"):(liveObj.pathUrl="/live/liveOnline/",liveObj.message="上线");
        let url = CONFIG.HOST + liveObj.pathUrl + row.id;
        co(function* (){
          let confirmResult = yield self.$confirm('确认是否'+liveObj.message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          console.log(confirmResult);
          let result = yield self.$http.put(url,{});
          if(result.body.status===1){
            row.liveOffline = (row.liveOffline+1)%2;
            self.$notify.success({
              message: liveObj.message+"成功"
            });
          }else{
            self.$notify.error({
              message: result.body.message
            });
          }
        })
        .catch((e)=>{
          if(e&&e==="cancel"){
            console.log("cancel");
            return;
          }
          self.$notify.error({
            message: liveObj.message+"失败"
          });
        });
      },
      //开启评论，关闭评论
      contralComment(index,row){
        let self = this;
        let liveObj = {
          pathUrl:null,
          message:null
        };
        //判断开启评论还是关闭评论
        row.isOpenComment===0?(liveObj.pathUrl="/live/openComment/",liveObj.message="开启评论"):(liveObj.pathUrl="/live/closeComment/",liveObj.message="关闭评论");
        let url = CONFIG.HOST + liveObj.pathUrl + row.id;
        co(function* (){
          let confirmResult = yield self.$confirm('确认是否'+liveObj.message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          console.log(confirmResult);
          let result = yield self.$http.put(url,{});
          if(result.body.status===1){
            row.isOpenComment = (row.isOpenComment+1)%2;
            self.$notify.success({
              message: liveObj.message+"成功"
            });
          }else{
            self.$notify.error({
              message: result.body.message
            });
          }
        })
        .catch((e)=>{
          if(e&&e==="cancel"){
            console.log("cancel");
            return;
          }
          self.$notify.error({
            message: liveObj.message+"失败"
          });
        });
      },
      //组件进入工作状态的钩子函数
      _init(){
        this.$http.get(CONFIG.HOST + "/live/liveListPaging/1").then((response)=>{
          let result = response.body;
          if (result && result.status === 1) {
            this.liveListData = result.data.liveListPaging;
            this.total = result.data.totalCounts[0].counts;
          } else {
            this.$notify.error({
              message: result.message
            });
          }
        }, (response)=>{
          console.log(response);
        });
      }
    },
    mounted(){
      this._init();
    }
  };
</script>
<style lang="less">
  .liveParent{
    width: 98%;
    min-width: 1000px;
    margin: 0 auto;
    position: relative;
    height: 100%;
    overflow: auto;
    .bread-nav{
      margin: 20px 0;
    }
    .live-table-expand {
      font-size: 0;
    }
    .live-table-expand label {
      width: 200px;
      color: #99a9bf;
    }
    .live-table-expand .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      text-align: left;
      width: 50%;
    }
    #liveUrl,#sourceUrl{
        width: 100%;
    }
    .editDialog{
      height: 75%;
      width: 60%;
      left: 50% !important;
      text-align: left;
      overflow: auto;
    }
    .el-pagination {
      margin-top: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// List.vue?c80795f0